import { atom } from 'jotai';
import { ReportSource } from 'c-main/Components/Campaign/CampaignReports/types';
import type {
    SummaryLayoutConfig,
    SummaryWidgetConfig,
    TopBoxConfig,
} from 'c-main/Components/Campaign/CampaignAnalytics/summaryCustomizationConfig';

export const atom_campaignUploadArtworkOpen = atom<boolean>(false);
export const atom_environmentMode = atom<string | null>(null);
export const atom_source = atom<ReportSource.ElasticSearch | ReportSource.Athena>(
    ReportSource.ElasticSearch,
);
export const atom_summaryCustomizationDialogOpen = atom<boolean>(false);
export const atom_campaignSummaryWidgetConfigs = atom<Record<string, SummaryWidgetConfig[]>>({});
// Per-campaign top-box customisation, keyed by getSummaryWidgetConfigKey → { [boxKey]: TopBoxConfig }.
export const atom_campaignTopBoxConfigs = atom<Record<string, Record<string, TopBoxConfig>>>({});
export const atom_campaignSummaryLayoutConfigs = atom<Record<string, SummaryLayoutConfig>>({});
export const atom_useLinearReportingOverride = atom<boolean>(false);
